<template>
  <div class="container">
    <div style="margin-bottom: 12px">
      <div class="mwow-button-filled success" @click="addStudents">
        添加请假学员
      </div>
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="resetSearch">
      <el-form ref="form" size="mini" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索:">
              <el-input
                v-model="searchInfo.key_word"
                placeholder="学员姓名/手机号"
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                clearable
                @change="handleSearch"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="处理状态:" prop="status">
              <el-select
                v-model="searchInfo.status"
                multiple
                clearable
                @change="handleSearch"
                placeholder="请选择"
                class="drawer_onlychoose"
                @focus="leaveStatusList"
              >
                <el-option
                  v-for="item in processing"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <div>
      <el-table
        ref="multipleTable"
        v-horizontal-scroll
        tooltip-effect="dark"
        style="width: 100%"
        :data="tableData"
        stripe
      >
        <el-table-column label="请假学员" prop="name">
          <template slot-scope="scope">
            <div v-if="scope.row.student">
              {{ scope.row.student.name || "-"
              }}<span
                v-if="scope.row.student.is_del === 1"
                class="mwow-tag del-filled large"
                >已删除</span
              >
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile">
          <template slot-scope="scope">
            <div>
              {{ "+" + scope.row.student.area_code }}
              {{ scope.row.student.mobile }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="请假时间">
          <template slot-scope="scope">
            <div>{{ scope.row.start_time }} ~ {{ scope.row.end_time }}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="create_time"> </el-table-column>
        <el-table-column label="处理状态" width="120">
          <template slot-scope="scope">
            <div
              :class="[
                scope.row.status == 3
                  ? 'delBtn'
                  : scope.row.status == 4
                  ? 'closeBtn'
                  : scope.row.status == 2
                  ? 'green'
                  : 'red',
              ]"
            >
              {{ scope.row.statusName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="处理时间" prop="update_time"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.status === 1"
              class="mwow-button success"
              @click="
                closeDrawer('agree', scope.row.id, scope.row.student.name)
              "
            >
              同意
            </div>
            <refuse-dialog :logId="scope.row.id" @close="handleRefresh">
              <div v-if="scope.row.status === 1" class="mwow-button danger">
                拒绝
              </div>
            </refuse-dialog>
            <div class="mwow-button primary" @click="lookDetails(scope.row)">
              查看
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
    <el-drawer title="请假详情" :visible.sync="drawer">
      <div class="drawer_box">
        <div class="drawer_Head">基本信息</div>
        <div class="drawer_box_headDetails">
          <el-row>
            <el-col :span="6">
              <div class="page_content_left">
                <el-avatar
                  shape="square"
                  :size="70"
                  fit="fit"
                  :src="drawerDetails.student.avatar_url"
                  class="page_content_avatar"
                ></el-avatar>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <div class="column">
                  <span class="vertica weight">{{
                    drawerDetails.student.name
                  }}</span>
                  <span class="light"></span>
                  <span class="vertica">{{
                    drawerDetails.student.sex == 0
                      ? "-"
                      : drawerDetails.student.sex == 1
                      ? "男"
                      : "女"
                  }}</span>
                </div>
                <div class="column">
                  <span class="vertica">{{
                    drawerDetails.student.mobile
                  }}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="approvalStatus"
                :class="{
                  bg: drawerDetails.status == 1,
                  agree: drawerDetails.status == 2,
                  unAgree: drawerDetails.status == 3,
                  revoke: drawerDetails.status == 4,
                }"
              >
                {{ drawerDetails.statusName }}
              </div>
            </el-col>
          </el-row>
          <div class="informationBox">
            <div class="column">
              <span class="vertica weight smsize">请假类型：</span>
              <span class="vertica smsize">{{
                drawerDetails.leave_type == 1
                  ? "事假"
                  : drawerDetails.leave_type == 2
                  ? "病假"
                  : "其他"
              }}</span>
            </div>
            <div class="column">
              <span class="vertica weight smsize">开始时间：</span>
              <span class="vertica smsize">{{
                dateYearMonthDay(drawerDetails.start_time)
              }}</span>
            </div>
            <div class="column">
              <span class="vertica weight smsize">结束时间：</span>
              <span class="vertica smsize">{{
                dateYearMonthDay(drawerDetails.end_time)
              }}</span>
            </div>
            <div class="column">
              <span class="vertica weight smsize">请假原因：</span>
              <span class="vertica smsize">{{
                drawerDetails.cause != "" ? drawerDetails.cause : "-"
              }}</span>
            </div>
            <div class="image-wrap">
              <img
                @click="showImageDialog(img.image_url)"
                v-for="(img, index) in drawerDetails.images"
                :key="index"
                :src="img.image_url"
                width="80"
                height="80"
              />
            </div>
          </div>
        </div>
        <div
          class="drawer_box_cenDetails"
          v-if="!!drawerDetails.student_leave_option_log"
        >
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in drawerDetails.student_leave_option_log"
              :key="index"
            >
              <div class="timelinebox">
                <div class="timelineboxLeft">
                  <div>{{ item.status == 1 ? "发起申请" : "审批人" }}</div>
                  <div class="timelineboxLefttn name">
                    {{ item.staff_name }}
                  </div>
                </div>
                <div class="timelineboxRight">
                  <div>{{ dateYearMonthDay(item.create_time) }}</div>
                  <div class="timelineboxLefttn">
                    <span v-if="item.status == 1">发起</span>
                    <span v-if="item.status == 2" style="color: #07d1aa"
                      >已批准</span
                    >
                    <span v-if="item.status == 3" style="color: #f56c6c"
                      >未批准</span
                    >
                    <p v-if="item.status == 3">{{ item.remark }}</p>
                    <span v-if="item.status == 4" style="color: #ffb940"
                      >撤销</span
                    >
                  </div>
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div
          class="drawer_Head_Name"
          v-if="drawerDetails.student_class_lesson.length > 0"
        >
          请假涉及课次
        </div>
        <div>
          <div
            class="classTimesCard"
            v-for="(item, index) in drawerDetails.student_class_lesson"
            :key="index"
            @click="
              goDetail(item.roll_call_status, item.lesson_id, item.roll_call_id)
            "
          >
            <div class="vertica weight smsize">{{ item.name }}</div>
            <div class="vertica smsize">
              {{ item.course_title }} -
              {{ item.class_lesson_type == 1 ? "线下" : "线上" }}
            </div>
            <div class="vertica smsize">{{ item.class_lesson_date }}</div>
          </div>
        </div>
        <div class="drawer_bottomBtn">
          <div>
            <div
              class="mwow-button-filled mini warning reloadbtn"
              v-if="drawerDetails.status == 2"
              @click="
                closeDrawer(
                  'revoke',
                  drawerDetails.id,
                  drawerDetails.student.name
                )
              "
            >
              撤销
            </div>
          </div>
          <div>
            <refuse-dialog :logId="drawerDetails.id" @close="handleRefresh">
              <div
                class="mwow-button-filled mini reloadbtn red"
                v-if="drawerDetails.status == 1"
              >
                拒绝
              </div>
            </refuse-dialog>
            <div
              class="mwow-button-filled mini success reloadbtn"
              v-if="drawerDetails.status == 1"
              @click="
                closeDrawer(
                  'agree',
                  drawerDetails.id,
                  drawerDetails.student.name
                )
              "
            >
              同意
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      :visible.sync="imageDialogVisible"
      title="图片预览"
      width="620px"
      height="620px"
    >
      <img :src="imageDialogSrc" alt="" style="width: 100%" />
    </el-dialog>
  </div>
</template>
<script>
import {
  leaveList,
  leaveListData,
  leaveStatus,
  leavedetail,
  leavePass,
  leaveCancel,
} from "@/api/rollCallRecord";
import { dateFormat } from "@/utils/timeFormat";
import refuseDialog from "./refuseDialog.vue";
import { PageModule } from "@/store/module/page";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
//差老师和课程顾问接口列表
export default {
  props: ["visible"],
  components: {
    refuseDialog,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        status: [1],
      }, //搜索数据
      tableData: [], //列表数据
      pageSize: 10,
      pageSizeArray: [10, 30, 50],
      total: 0,
      page: 1,
      processing: [
        {
          key: 1,
          value: "审批中",
        },
      ],
      drawer: false,
      dialogForm: {},
      drawerDetails: {
        student_class_lesson: [],
        student: {},
      },
      leave_id: 0,
      imageDialogVisible: false,
      imageDialogSrc: "",
    };
  },
  created() {
    const _t = this;
    if (
      PageModule.latestRoute === "classTimeDetails" ||
      PageModule.latestRoute === "rollCallDetails" ||
      PageModule.latestRoute === "leaveAppliDetails"
    ) {
      // 内页返回
      const cache = PageModule.pageInfo.rollCallRecordList;
      if (cache.leaveAppLicationPage) {
        _t.page = cache.leaveAppLicationPage;
      } else {
        PageModule.SET_PAGE_INFO({
          name: "rollCallRecordList",
          key: "leaveAppLicationPage",
          value: _t.page,
        });
      }
    }
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        _t.getList({
          page: _t.page,
          page_size: _t.pageSize,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      _t.getList({
        page: _t.page,
        page_size: _t.pageSize,
      });
    }
  },
  methods: {
    resetSearch() {
      this.searchInfo = {
        status: [],
      };
      this.page = 1;
      this.pageSize = 10;
      this.getList({
        page: 1,
        page_size: 10,
      });
    },
    lookDetails(e) {
      const _t = this;
      _t.leave_id = e.id;
      leavedetail({ leave_id: e.id }).then((res) => {
        if (res.error_code == 0) {
          _t.drawer = true;
          switch (res.data.status) {
            case 1:
              res.data.statusName = "审批中";
              break;
            case 2:
              res.data.statusName = "已批准";
              break;
            case 3:
              res.data.statusName = "未批准";
              break;
            case 4:
              res.data.statusName = "撤销";
              break;
          }
          _t.drawerDetails = res.data;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    addStudents() {
      const _t = this;
      _t.$router.push({ name: "leaveAppliDetails" });
    },
    dateYearMonthDay(unixtime) {
      return dateFormat("YYYY-mm-dd HH:MM", new Date(Number(unixtime + "000")));
    },
    getList(data) {
      const _t = this;
      if (_t.searchInfo.key_word != "") {
        data.key_word = _t.searchInfo.key_word;
      }
      if (this.searchInfo.status.length != "") {
        data.status = this.searchInfo.status;
      }
      leaveList(data).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            res.data.list.map((a) => {
              a.create_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.create_time + "000"))
              );
              const days = dateFormat(
                "YYYY-mm-dd",
                new Date(Number(a.start_time + "000"))
              );
              const endday = dateFormat(
                "YYYY-mm-dd",
                new Date(Number(a.end_time + "000"))
              );
              if (days == endday) {
                a.start_time = dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(Number(a.start_time + "000"))
                );
                a.end_time = dateFormat(
                  "HH:MM",
                  new Date(Number(a.end_time + "000"))
                );
              } else {
                a.start_time = dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(Number(a.start_time + "000"))
                );
                a.end_time = dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(Number(a.end_time + "000"))
                );
              }
              a.update_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.update_time + "000"))
              );
              switch (a.status) {
                case 1:
                  a.statusName = "审批中";
                  break;
                case 2:
                  a.statusName = "已批准";
                  break;
                case 3:
                  a.statusName = "未批准";
                  break;
                case 4:
                  a.statusName = "撤销";
                  break;
              }
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    leaveStatusList() {
      const _t = this;
      if (_t.processing.length > 1) {
        return false;
      }
      leaveStatus().then((res) => {
        if (res.error_code == 0) {
          _t.processing = res.data.list;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handleSearch() {
      const _t = this;
      this.getList({
        page: 1,
        page_size: _t.pageSize,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
      this.drawer = false;
    },
    handlePagerChange(e) {
      PageModule.SET_PAGE_INFO({
        name: "rollCallRecordList",
        key: "leaveAppLicationPage",
        value: e,
      });
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    closeDrawer(type, lid, name) {
      const _t = this;
      if (type == "revoke") {
        _t.$confirm(
          "撤销后请假申请将失效，对应的签到及消课状态不会发生变化，需要手动调整课时签到状态，撤销后无法恢复。",
          `撤销 - ${name}请假`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            leaveCancel({ leave_id: lid }).then((res) => {
              if (res.error_code == 0) {
                _t.$message({
                  type: "success",
                  message: "撤销成功",
                });
                _t.getList({
                  page: _t.page,
                  page_size: _t.pageSize,
                });
                _t.drawer = false;
              }
            });
          })
          .catch(() => {});
      } else if (type == "agree") {
        _t.$confirm(
          "同意后，会给学员与教师推送通知，学员在请假时间内的课时状态会自动变更，但依然允许在点名中修改。",
          `同意 - ${name}请假`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            leavePass({ leave_id: lid }).then((res) => {
              if (res.error_code == 0) {
                _t.$message({
                  type: "success",
                  message: "同意成功",
                });
                _t.getList({
                  page: _t.page,
                  page_size: _t.pageSize,
                });
                _t.drawer = false;
              }
            });
          })
          .catch(() => {});
      }
    },
    showImageDialog(src) {
      this.imageDialogVisible = true;
      this.imageDialogSrc = src;
    },
    goDetail(status, lid, rowCallId) {
      // 课次详情
      if (status === 1) {
        this.$router.push({
          name: "classTimeDetails",
          query: {
            id: lid,
          },
        });
        // 点名详情
      } else if (status === 2) {
        this.$router.push({
          name: "rollCallDetails",
          query: {
            id: rowCallId,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .autocompletename {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .autocompleteaddr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .autocompleteaddr {
      color: #ddd;
    }
  }
}
.el-form .el-form-item__label {
  text-align: left !important;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 12px !important;
  margin-right: 80px !important;
}
.operationBox {
  div:nth-of-type(2) {
    margin: 0 10px;
  }
}
.drawer_box {
  padding: 0 5%;
}
.drawer_Head {
  font-size: 14px;
  color: #5c5d5e;
  margin-bottom: 14px;
  margin-top: 14px;
  font-weight: bold;
}
.drawer_Head_Name {
  font-size: 14px;
  color: #5c5d5e;
  margin-bottom: 14px;
  font-weight: bold;
}
.drawer_bottomBtn {
  display: flex;
  justify-content: space-between;
  max-width: 380px;
  padding-bottom: 30px;
  .reloadbtn {
    margin-left: 12px;
  }
  .red {
    background: #f56c6c;
    color: #fff;
    border-color: #f56c6c;
  }
  .warning {
    margin-left: 0;
  }
}
.page_content_avatar {
  border-radius: 50%;
  border: 1px solid #e7e8ea;
}
.column {
  display: flex;
  align-items: center;
  min-height: 35px;
  text-align: center;
}
.column span:nth-of-type(1) {
  min-width: 75px;
}
.vertica {
  font-size: 16px;
  color: rgba(92, 93, 94, 1);
}
.light {
  width: 1px;
  height: 16px;
  background-color: #dcdfe6;
  display: inline-block;
  margin: 0 10px;
}
.weight {
  font-weight: bold;
}
.smsize {
  font-size: 14px;
}
.approvalStatus {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  opacity: 1;
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
}
.bg {
  background: #98999a;
}
.agree {
  background: #07d1aa;
}
.unAgree {
  background: #f56c6c;
}
.revoke {
  background: #ffb940;
}
.informationBox {
  .column {
    margin-bottom: 5px;
  }
  .image-wrap {
    margin-left: 70px;
    img {
      margin-right: 12px;
      cursor: pointer;
      border: 1px solid #e7e8ea;
      border-radius: 8px;
    }
  }
}
.drawer_box_headDetails,
.drawer_box_cenDetails {
  padding: 5px 10px;
  border-bottom: 1px solid #e7e8ea;
}
.drawer_box_cenDetails {
  padding-top: 25px;
  margin-bottom: 30px;
}
.timelinebox {
  display: flex;
  justify-content: space-between;
  .timelineboxLeft,
  .timelineboxRight {
    color: #5c5d5e;
    font-weight: bold;
  }
  .timelineboxRight {
    text-align: right;
  }
  .timelineboxLefttn {
    padding-left: 10px;
    font-weight: normal;
    margin-top: 8px;
  }
  .timelineboxLefttn {
    color: #c2c3c4;
    font-weight: normal;
    margin-top: 8px;
  }
  .timelineboxLefttn.name {
    color: #5c5d5e;
  }
}
.classTimesCard {
  cursor: pointer;
  padding: 10px;
  border: 1px solid #e7e8ea;
  border-radius: 4px;
  margin-bottom: 16px;
  .smsize {
    font-size: 12px;
    margin-bottom: 8px;
  }
  .smsize:last-child {
    margin-bottom: 0;
  }
}
.FoUpBtn {
  color: #409eff;
}
.editBtn {
  color: #07d1aa;
}
.closeBtn {
  color: #ffb940;
}
.delBtn {
  color: #5c5d5e;
}
.red {
  color: #f56c6c;
}
.green {
  color: #07d1aa;
}
</style>
